module.exports = __webpack_public_path__ + "img/btn_apple@3x@2x.495dd3f2.png";